import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { Region } from '../../BookingsCalendarTypes';

type AdvancedRegionFilterLabels = {
    region: string;
    allRegions: string;
};

type AdvancedRegionFilterProps = {
    labels: AdvancedRegionFilterLabels;
    disabled: boolean;
    availableRegions: Region[];
    selectedRegion: number;
    onChangeRegion?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function AdvancedRegionFilter({
    disabled,
    labels,
    selectedRegion,
    onChangeRegion,
    availableRegions
}: AdvancedRegionFilterProps) {
    return (
        <TextField
            select
            aria-label={'advanced-regions-select'}
            label={[labels.region]}
            id="advanced-regions-select"
            name={'advancedSelectRegion'}
            value={selectedRegion}
            onChange={onChangeRegion}
            sx={{ marginRight: '8px', width: '250px' }}
            disabled={disabled}
        >
            <MenuItem value={0} sx={{ fontWeight: '600' }}>
                {labels.allRegions}
            </MenuItem>
            {availableRegions.map((region) => (
                <MenuItem key={region.id} value={region.id}>
                    {region.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
